import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { LineItemModels, LineItemMappers, LineItemCard } from '@grandvisionhq/lib-visuals';
import { useIntl } from '@grandvisionhq/state';

const LineItemsContainer = ({ lineItems  })=>{
    const intl = useIntl();
    const labels = React.useMemo(()=>({
            quantity: intl.getLabel('cart.item.quantity'),
            iconLeftEye: intl.getLabel('products.contactLenses.leftEye'),
            iconRightEye: intl.getLabel('products.contactLenses.rightEye'),
            power: intl.getLabel('products.contactLenses.prescription.power'),
            monthlySubscription: intl.getLabel('products.monthlySubscription'),
            deliveredEvery: intl.getLabel('cart.delivery.frequency'),
            perBox: intl.getLabel('products.perBox'),
            configuration: intl.getLabel('account.order.detail.configuration'),
            prescription: intl.getLabel('account.order.detail.prescription'),
            subscriptionDetails: intl.getLabel('cart.item.subscription.title'),
            addOn: intl.getLabel('products.addOn.title')
        })
    , [
        intl
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, lineItems.map((lineItem, i)=>{
        var ref;
        const accordionSection = [];
        if ('prescription' in lineItem) {
            if (LineItemModels.isGlassesBundleLineItem(lineItem)) {
                accordionSection.push({
                    type: 'GLASSES_BUNDLE',
                    title: labels.prescription,
                    prescription: lineItem.prescription
                });
            } else if (lineItem.prescription) {
                accordionSection.push({
                    type: 'CONTACT_LENSES',
                    title: labels.prescription,
                    prescription: lineItem.prescription
                });
            }
        }
        if (lineItem.isSubscription && ((ref = lineItem.subscriptionDetails) === null || ref === void 0 ? void 0 : ref.deliveryInterval)) {
            accordionSection.push({
                type: 'SUBSCRIPTION',
                title: labels.subscriptionDetails,
                expanded: true,
                deliveryInterval: lineItem.subscriptionDetails.deliveryInterval
            });
        }
        if ('bundleChildLineItems' in lineItem && lineItem.bundleChildLineItems) {
            var ref1;
            const bundleChildLineItems = LineItemMappers.getEnrichedBundleChildLineItems({
                lineItem,
                addOnLabel: labels.addOn
            });
            accordionSection.push({
                type: 'CONTACT_LENS_BUNDLE',
                title: labels.configuration,
                bundleChildLineItems,
                expanded: Boolean((ref1 = lineItem.insurance) === null || ref1 === void 0 ? void 0 : ref1.sku)
            });
        }
        const baseProps = {
            currency: intl.currency,
            discountPrice: lineItem.discountPrice ? lineItem.price : 0,
            imagePath: lineItem.imageUrl,
            lineItemId: lineItem.lineItemId,
            price: lineItem.discountPrice && lineItem.originalPrice ? lineItem.originalPrice : lineItem.price,
            quantity: lineItem.quantity,
            subtitle: lineItem.subtitle,
            title: lineItem.title,
            compactCard: true,
            accordionSection,
            additionalInfo: lineItem.additionalInfo
        };
        return /*#__PURE__*/ React.createElement(LineItemCard, swcHelpers.extends({
            key: `${lineItem.lineItemId}+${i}`
        }, baseProps));
    }));
};

export { LineItemsContainer };
//# sourceMappingURL=LineItemContainer.js.map
